import { forwardRef, useCallback } from "react";

import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

import { chartOfAccountTypeLabels } from "@/features/chart-of-accounts";
import { apiOutletClient } from "@/features/shared";
import { CustomAutocomplete } from "@/features/ui";

export const OutletChartOfAccountSelect = forwardRef(
  ({ outletId, types, ...props }, ref) => {
    const fetchOutletChartOfAccounts = useCallback(async () => {
      if (!outletId) return [];

      const {
        data: { data },
      } = await apiOutletClient.get("chart-of-accounts", {
        params: {
          leafOnly: true,
          ...(types?.length && { types }),
        },
        headers: {
          "Outlet-Id": outletId,
        },
      });

      return data;
    }, [outletId, types]);

    return (
      <CustomAutocomplete
        ref={ref}
        fetchOptions={fetchOutletChartOfAccounts}
        getOptionLabel={(option) => `${option.code} - ${option.name}`}
        renderOption={(props, option) => {
          // eslint-disable-next-line react/prop-types
          const { key, ...otherProps } = props;
          return (
            <Box component="li" key={key} {...otherProps}>
              <Box>
                <Typography variant="body2">
                  {option.code} - {option.name}
                </Typography>
                <Typography variant="caption" sx={{
                  color: "text.secondary"
                }}>
                  {chartOfAccountTypeLabels[option.type]}
                </Typography>
              </Box>
            </Box>
          );
        }}
        isOptionEqualToValue={(option, selectedOption) =>
          option.id === selectedOption.id
        }
        {...props}
      />
    );
  }
);

OutletChartOfAccountSelect.displayName = "OutletChartOfAccountSelect";

OutletChartOfAccountSelect.propTypes = {
  outletId: PropTypes.string.isRequired,
  types: PropTypes.arrayOf(PropTypes.string),
};
